import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';

export const ArticlesType = {
  commentary: ThemeType.commentary,
  dealFlow: ThemeType.dealFlow,
};

export const mapArticleTypeToTitle = {
  [ArticlesType.commentary]: 'Commentary',
  [ArticlesType.dealFlow]: 'Deal Flow',
};
